import { Code } from "callable-data-objects";
import { useCodeDeck } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import { Button, Card, Grid, Header, Input, Table } from "semantic-ui-react";

const CodeDeckCodes = () => {
  const {
    codeDeck,
    selectCode,
    searchCode,
    setSearchCode,
    createCodeDeckCode,
  } = useCodeDeck();

  const codes = codeDeck.codes
    .filter(
      (c: Code) =>
        !searchCode ||
        c.caller.indexOf(searchCode) > -1 ||
        c.called.indexOf(searchCode) > -1
    )
    .splice(0, 20);

  return (
    <Fragment>
      <Header as='h3'>Codes</Header>
      <Card fluid>
        <Card.Content>
          <Grid stackable padded>
            <Grid.Column width={14}>
              <Input
                value={searchCode}
                placeholder='Search...'
                onChange={(value, data) => setSearchCode(data.value)}
                icon='search'
              />
            </Grid.Column>
            <Grid.Column width={2} style={{ textAlign: "right" }}>
              <Button primary onClick={() => createCodeDeckCode()}>
                Create
              </Button>
            </Grid.Column>
          </Grid>

          <Table celled padded stackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell singleLine>ID</Table.HeaderCell>
                <Table.HeaderCell singleLine>Caller</Table.HeaderCell>
                <Table.HeaderCell singleLine>Called</Table.HeaderCell>
                <Table.HeaderCell singleLine>Category</Table.HeaderCell>
                <Table.HeaderCell singleLine>Code</Table.HeaderCell>
                <Table.HeaderCell singleLine>Country</Table.HeaderCell>
                <Table.HeaderCell singleLine>Country Code</Table.HeaderCell>
                <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {codes.map((c: Code) => (
                <Table.Row key={`tr-ddi-${c.id}`}>
                  <Table.Cell singleLine>{c.id}</Table.Cell>
                  <Table.Cell singleLine>{c.caller}</Table.Cell>
                  <Table.Cell singleLine>{c.called}</Table.Cell>
                  <Table.Cell singleLine>{c.category}</Table.Cell>
                  <Table.Cell singleLine>{c.code}</Table.Cell>
                  <Table.Cell singleLine>{c.country}</Table.Cell>
                  <Table.Cell singleLine>{c.countryCode}</Table.Cell>
                  <Table.Cell textAlign='left'>
                    <Button
                      primary
                      size='tiny'
                      onClick={() => selectCode(c.id)}
                    >
                      Select
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Card.Content>
      </Card>
    </Fragment>
  );
};

export default CodeDeckCodes;
